/* eslint-disable max-len */
import React from 'react';
import { toPathNoDoubleSlash } from '../../../CodesThatsGottaGoSomewhereElse';
import { Grid } from '../../../ui';
import { FadeIn } from '../../../ui/Transitions';
import { useResolve } from '../../Container';
import { AccountHeaderBlock } from '../../account/AccountHeaderBlock';
import { PlanStateHeaderBlock } from '../../account/PlanStateHeaderBlock';
import { TeaserHeader } from '../../account/TeaserHeader';
import { Page2 } from '../../common/Page2';
import { useReturnLocation } from '../../common/ReturnLocation';
import { NewCreateStrip } from '../../workspace/NewCreateStrip';
import { WorkspaceModel } from '../Models';
import { Flexer } from '../elements/LayoutElements';
import { RecentBoardsBrowser } from './RecentBoardsBrowser';
import { TeamProductTips } from './TeamProductTips';

export const RecentBoardsView = () => {

    const workspace = useResolve(WorkspaceModel);
    useReturnLocation(toPathNoDoubleSlash([workspace.id, 'recent']));

    return <Page2.Scroll>
        <Page2.Header>
            <Grid style={{ width: '100%' }} columns="auto min-content min-content">
                <TeaserHeader />
                <PlanStateHeaderBlock />
                <AccountHeaderBlock />
            </Grid>
        </Page2.Header>
        <Page2.Content>
            <FadeIn>
                <NewCreateStrip forcePromptForLocation />
            </FadeIn>
            <Flexer height="2.25" />
            <FadeIn>
                <RecentBoardsBrowser />
            </FadeIn>
            <Flexer height="4" />
            <TeamProductTips />
            <Flexer height="8" />
        </Page2.Content>
    </Page2.Scroll>;
};

{/* <Observer store={useResolve(WorkspaceModel)} render={({ joined, boards, folders }) => */ }

